import React, { Component } from "react";
import Table from "../../../common/table/NewTable";
import { Location, History } from "history";
import { match } from "react-router";
import ContributorService from "../../../../services/contributor/ContributorService";
import { onFailAction } from "../../../../helpers/SwalCommon";
import TableActionButton from "./action-button/TableActionButton";
import { STATUS_LABEL_CLASS } from "../ContributorEnum";
import { formatDateTime, checkPermission } from "../../../../helpers/NewCaHelper";
import { Tag } from "antd";

interface Props {
  location: Location;
  history: History;
  match: match;
  user: any;
}
interface State { }

const per_view_detail_ctv = 'view-detail-ctv-ad';

export default class ContributorTable extends Component<Props, State> {
  state = {};

  componentDidMount() {
    this.fetch();
  }

  fetch = async (params = {}) => {
    this.setState({ loading: true });
    const service = new ContributorService();
    try {
      const agency = await service.getContributors(params);
      return agency;
    } catch (error) {
      console.log(error);
            onFailAction();
    }
  };

  render() {
    return (
      <Table
        columns={this.columns}
        onFetchData={this.fetch}
      />
    );
  }

  onRenderActionColumn = (text, record, index) => {
    return (
      <TableActionButton
        onClickLock={() => true}
        onClickUpdate={() =>
          this.props.history.push(`/cong-tac-vien/cap-nhat/${record.id}`)
        }
        isDisplayLockButton={false}
        isDisplayUpdateButton={this.checkUpdateAble(record)}
      />
    );
  };

  checkUpdateAble = (record: any): any => {
    if (!checkPermission(per_view_detail_ctv)) return false;
    return true;
  };

  renderStatusColumn = (text, record, index) => {
    return (
      <Tag color={`${STATUS_LABEL_CLASS[text].class}`}>
        {STATUS_LABEL_CLASS[text].label}
      </Tag>
    );
  };

  columns = [
    { title: "Mã cộng tác viên", dataIndex: "code" },
    { title: "Chứng minh thư", dataIndex: "passport" },
    {
      title: "Trạng thái",
      dataIndex: "status",
      render: this.renderStatusColumn
    },
    { title: "Tên cộng tác viên", dataIndex: "fullname" },
    { title: "Email", dataIndex: "email" },
    { title: "SĐT", dataIndex: "phone" },
    { title: "Người quản lý", dataIndex: "sale_fullname" },
    {
      title: "Thời gian tạo",
      dataIndex: "created_at",
      render: (text, record, index) => formatDateTime(text)
    },
    {
      title: "Tác vụ",
      render: this.onRenderActionColumn
    }
  ];
}
